import { AssetCreateTypeEnum } from "app/components/MediaUploader/types";

const VIDEO_EXTENSIONS = /\.(mp4|webm|ogg|ogv|mov|m4v|mkv|avi)(\?|$)/i;
const AUDIO_EXTENSIONS = /\.(mp3|wav|aac|m4a|flac|opus|weba|oga)(\?|$)/i;
const CODE_OR_TEXT_EXT =
  /\.(txt|csv|md|mdx|log|rtf|js|jsx|mjs|cjs|ts|tsx|json|yaml|yml|sql|sh|bash|zsh|env|xml|html|htm|css|scss|less|ini|toml|graphql|gql|vue|properties|plist)(\?|$)/i;

export const getAttachmentAssetType = (
  mimeType?: string,
  fileName?: string,
): AssetCreateTypeEnum => {
  const normalizedMimeType = (mimeType || "").toLowerCase();
  const normalizedName = (fileName || "").toLowerCase();

  if (
    normalizedMimeType.includes("pdf") ||
    normalizedName.endsWith(".pdf")
  ) {
    return AssetCreateTypeEnum.PDF;
  }

  if (normalizedMimeType.startsWith("image/")) {
    return AssetCreateTypeEnum.IMAGE;
  }

  if (
    normalizedMimeType.startsWith("video/") ||
    VIDEO_EXTENSIONS.test(normalizedName)
  ) {
    return AssetCreateTypeEnum.VIDEO;
  }

  if (
    normalizedMimeType.startsWith("audio/") ||
    AUDIO_EXTENSIONS.test(normalizedName)
  ) {
    return AssetCreateTypeEnum.AUDIO;
  }

  const isTextOrCodeLike =
    normalizedMimeType === "application/json" ||
    normalizedMimeType === "application/xml" ||
    normalizedMimeType === "text/xml" ||
    normalizedMimeType === "text/html" ||
    normalizedMimeType === "text/css" ||
    normalizedMimeType === "text/x-yaml" ||
    normalizedMimeType === "application/x-yaml" ||
    normalizedMimeType.includes("javascript") ||
    normalizedMimeType.includes("typescript") ||
    normalizedMimeType.startsWith("text/") ||
    CODE_OR_TEXT_EXT.test(normalizedName);

  if (isTextOrCodeLike) {
    return AssetCreateTypeEnum.TEXT;
  }

  return AssetCreateTypeEnum.DOC;
};

